<script setup lang="ts">
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import './epp-shared.css';

const { t } = useI18n({ useScope: 'global' });

defineProps<{
  displayImg: string | null;
  existingImgUrl: string | null;
  imgFile: File | null;
}>();

const emit = defineEmits<{
  change: [e: Event];
  remove: [];
}>();

const imgInputRef = ref<HTMLInputElement | null>(null);

function onChange(e: Event) {
  emit('change', e);
}
</script>

<template>
  <div class="epp__img-upload">
    <div class="epp__img-preview-wrap">
      <img
        v-if="displayImg"
        :src="displayImg"
        class="epp__img-preview"
        alt="aperçu"
      />
      <div v-else class="epp__img-placeholder">
        <i class="pi pi-camera" />
      </div>
      <span v-if="existingImgUrl && !imgFile" class="epp__img-current-badge">{{
        t('product.currentImageBadge')
      }}</span>
    </div>
    <div class="epp__img-actions">
      <input
        ref="imgInputRef"
        type="file"
        accept="image/*"
        style="display: none"
        @change="onChange"
      />
      <button class="epp__btn epp__btn--outline" @click="imgInputRef?.click()">
        <i class="pi pi-upload" />
        {{
          imgFile
            ? t('product.changeImage')
            : existingImgUrl
              ? t('product.replaceImage')
              : t('product.chooseImage')
        }}
      </button>
      <button
        v-if="imgFile"
        class="epp__btn epp__btn--ghost"
        @click="emit('remove')"
      >
        <i class="pi pi-times" /> {{ t('product.cancel') }}
      </button>
      <span v-if="imgFile" class="epp__filename">{{ imgFile.name }}</span>
    </div>
  </div>
</template>
